import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from "@angular/core";
import { ButtonDirective, ButtonSeverity } from "primeng/button";
import { Tooltip } from "primeng/tooltip";
import {
  onlineCarrierStatus,
  OnlineCarrierStatus,
} from "../../../rate/online-carrier-status.const";

// A connected carrier needs no icon: the green button already says so.
const statusIcons: Record<OnlineCarrierStatus, string | null> = {
  [onlineCarrierStatus.connected]: null,
  [onlineCarrierStatus.notConnected]: "pi-sort-alt-slash",
  [onlineCarrierStatus.connectionIssue]: "pi-exclamation-triangle",
  [onlineCarrierStatus.renewable]: "pi-refresh",
};

const statusSeverities: Record<OnlineCarrierStatus, ButtonSeverity> = {
  [onlineCarrierStatus.connected]: "success",
  [onlineCarrierStatus.notConnected]: "secondary",
  [onlineCarrierStatus.connectionIssue]: "warn",
  [onlineCarrierStatus.renewable]: "warn",
};

const statusTooltips: Record<OnlineCarrierStatus, string> = {
  [onlineCarrierStatus.connected]: "",
  [onlineCarrierStatus.notConnected]: "Not connected",
  [onlineCarrierStatus.connectionIssue]: "Connection issue",
  [onlineCarrierStatus.renewable]: "Connection expired, click to renew",
};

@Component({
  selector: "app-online-carrier-button",
  templateUrl: "./online-carrier-button.component.html",
  styleUrls: ["./online-carrier-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, Tooltip],
})
export class OnlineCarrierButtonComponent {
  public readonly label = input.required<string>();
  public readonly status = input.required<OnlineCarrierStatus>();
  public readonly loading = input(false);
  public readonly loadingLabel = input("Loading...");
  public readonly disabled = input(false);
  public readonly loadRates = output<void>();

  // A renewable carrier loads too: the backend answers with a renewal under way instead of rates.
  public readonly loadable = computed(
    () =>
      this.status() === onlineCarrierStatus.connected ||
      this.status() === onlineCarrierStatus.renewable,
  );
  public readonly severity = computed(() => statusSeverities[this.status()]);
  public readonly icon = computed(() => statusIcons[this.status()]);
  public readonly tooltip = computed(() => statusTooltips[this.status()]);

  public onClick(): void {
    if (this.loadable()) {
      this.loadRates.emit();
    }
  }
}
